module.exports = __webpack_public_path__ + "static/img/click@2x.4d1a120d.png";